import { NgModule } from '@angular/core';
import { StoreService } from './store.service';
import { AuthStoreModule } from '../auth/+store/auth-store.module';
import { ProvisionRequestsStoreModule } from '../provisions/+store/provision-requests-store.module';
import { LockerStoreModule } from '../lockers/+store/locker-store.module';
import { PersonsStoreModule } from '../persons/+store/persons-store.module';
import { ClothingStoreModule } from '../clothing/+store/clothing-store.module';
import { TableStateStoreModule } from '../shared/services/table-state/table-state-store.module';

@NgModule({
  imports: [
    AuthStoreModule,
    ProvisionRequestsStoreModule,
    LockerStoreModule,
    PersonsStoreModule,
    ClothingStoreModule,
    TableStateStoreModule,
  ],
  providers: [StoreService],
})
export class StoreModule {}
